import ResetPasswordConfirmation from './ResetPasswordConfirmation';

export default ResetPasswordConfirmation;
